// 图片地址
export function imageUrl(url, suffix = '', defaultUrl) {
  if (!url) {
    return (
      defaultUrl ||
      '//www.zai-art.com/appwrapper_dist/appDefaultImage/empty.png'
    )
  }

  return /(http)|(https)|(\/\/)/gi.test(url)
    ? url.replace(/(^http:)|(^https:)/gi, '') + suffix
    : '//img.zai-art.com/' + url + suffix
}

// 图片className
export function imageClass(url, width, height, multiple = 1) {
  let className = ''
  if (width / height <= multiple) {
    className = 'imgFullW'
  } else {
    className = 'imgFullH'
  }
  return className
}

// 内容解析
export function resolveContent(value, maxWidth) {
  let result = ''
  if (!value) return result
  result = value.replace(/<img.*?>/gi, function(img, p2) {
    return img
      .replace(/src="([\s|\S]*?)"/gi, function(src, url) {
        let tampUrl = /(http)|(https)|(\/\/)/gi.test(url)
          ? url.replace(/(^http:)|(^https:)/gi, '')
          : `//img.zai-art.com/${url}`
        let imageViewSrc = ''
        if (maxWidth) {
          imageViewSrc = `${tampUrl}?imageView2/2/w/${maxWidth}`
        } else {
          imageViewSrc = `${tampUrl}?imageslim`
        }
        return `src="${imageViewSrc}" data-src="${tampUrl}"`
      })
      .replace(/( style=".*?")|( width="[\d]*?")|( height="[\d]*?")/gi, '')
  })
  return result
}

// 日期范围格式化
// 2017.07.16-09.16
export function formatDateRange(startTime, endTime) {
  let result = ''
  let startDate = startTime ? new Date(startTime) : null
  let endDate = endTime ? new Date(endTime) : null

  if (!startDate) return result
  result +=
    startDate.getFullYear() +
    '.' +
    leftPad(startDate.getMonth() + 1) +
    '.' +
    leftPad(startDate.getDate())

  if (endDate) {
    let year =
      startDate.getFullYear() !== endDate.getFullYear()
        ? endDate.getFullYear() + '.'
        : ''
    result +=
      '-' +
      year +
      leftPad(endDate.getMonth() + 1) +
      '.' +
      leftPad(endDate.getDate())
  }
  return result
}

// 日期格式化
export function formatDateTime(timestamp) {
  let result = ''
  if (!timestamp) return result

  let date = new Date(timestamp)
  let year = date.getFullYear()
  let month = leftPad(date.getMonth() + 1)
  let day = leftPad(date.getDate())
  let hours = leftPad(date.getHours())
  let minutes = leftPad(date.getMinutes())

  if (year === new Date().getFullYear()) {
    result = `${month}-${day} ${hours}:${minutes}`
  } else {
    result = `${year}-${month}-${day} ${hours}:${minutes}`
  }
  return result
}

// 日期格式化
export function formatDateTimeYear(timestamp) {
  let result = ''
  if (!timestamp) return result

  let date = new Date(timestamp)
  let year = date.getFullYear()
  let month = leftPad(date.getMonth() + 1)
  let day = leftPad(date.getDate())
  let hours = leftPad(date.getHours())
  let minutes = leftPad(date.getMinutes())
  let seconds = leftPad(date.getSeconds())

  result = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
  return result
}

// 日期格式化
export function formatDate(value) {
  let date = null
  if (value) {
    date = new Date(value)
    return (
      date.getFullYear() +
      '.' +
      leftPad(date.getMonth() + 1) +
      '.' +
      leftPad(date.getDate())
    )
  } else {
    return ''
  }
}

// 左侧补零
function leftPad(n) {
  return n < 10 ? '0' + n : n
}

export function commonListfilter(value, name) {
  switch (name) {
    case 'tradeType':
      // 商品类型
      return getTradeType(value)
    case 'createTime':
    case 'endTime':
    case 'pushTime':
    case 'startTime':
    case 'tradeCompleteTime':
      // 时间 yyyy-mm-dd hh:mm:ss
      return formatDateTimeYear(value)
    case 'auditTime':
      // 时间 yyyy-mm-dd
      return formatDate(value)
    case 'ticketIsUse':
      // 商品类型
      return getTicketIsUse(value)
    case 'sceneType':
      // 场景
      return formatScene(value)
    case 'tradeState':
      // 订单状态
      return formatTradeState(value)
    case 'dayCount':
    case 'sellCount':
    case 'useCount':
    case 'allUseCount':
      // 今日销售数量
      return formatNumber(value)
    default:
      return value
  }
}

// 商品类型
function getTradeType(value) {
  if (value === 1) {
    return '消费'
  } else if (value === 2) {
    return '零钱提现到支付宝'
  } else if (value === 3) {
    return '直播收入提现到零钱'
  } else if (value === 4) {
    return '电子票'
  } else {
    return '未知'
  }
}

// 商品类型
function getTicketIsUse(value) {
  if (value === 0) {
    return '未使用'
  } else if (value === 1) {
    return '已使用'
  } else {
    return '未知'
  }
}

// 订单场景
function formatScene(value) {
  if (value === null) {
    return '线上'
  } else if (value === 'ONLINE') {
    return '线上'
  } else if (value === 'OFFLINE') {
    return '线下'
  } else {
    return '线上'
  }
}

// 订单状态
function formatTradeState(value) {
  switch (value) {
    case 'WAIT_PAY':
      return '等待支付'
    case 'CANCEL':
      return '取消'
    case 'WAIT_SHIPMENT':
      return '待发货'
    case 'WAIT_CONFIRM_RECEIPT':
      return '待收货'
    case 'REFUNDING':
      return '退款中'
    case 'REFUNDED':
      return '已退款'
    case 'SUCCESS':
      return '成功'
    default:
      return '不限'
  }
}

// 订单场景
function formatNumber(value) {
  if (!value || value === null) {
    return 0
  } else {
    return value
  }
}
